<template lang="html">
  <article class="flex flex-col gap-2 border-b border-default py-4">
    <header class="flex flex-wrap items-center gap-2 text-sm">
      <RatingStars :value="props.review.rating" />
      <span class="font-semibold">{{ props.review.authorName }}</span>
      <time class="text-muted" :datetime="props.review.date">{{ date }}</time>
      <UBadge
        v-if="props.review.isVerifiedPurchase"
        label="Проверенная покупка"
        color="primary"
        variant="subtle"
        size="sm"
      />
    </header>

    <p v-if="attributes" class="text-xs text-muted">
      {{ attributes }}
    </p>

    <dl class="flex flex-col gap-2 text-sm">
      <div v-if="props.review.pros">
        <dt class="font-semibold">
          Достоинства
        </dt>
        <dd class="whitespace-pre-wrap">
          {{ props.review.pros }}
        </dd>
      </div>
      <div v-if="props.review.cons">
        <dt class="font-semibold">
          Недостатки
        </dt>
        <dd class="whitespace-pre-wrap">
          {{ props.review.cons }}
        </dd>
      </div>
      <div v-if="props.review.text">
        <dt class="font-semibold">
          Комментарий
        </dt>
        <dd class="whitespace-pre-wrap">
          {{ props.review.text }}
        </dd>
      </div>
    </dl>

    <ReviewPhotosLightbox v-if="props.review.imageIds?.length" :image-ids="props.review.imageIds" />

    <div v-if="props.review.reply" class="ml-4 border-l-2 border-primary pl-3 text-sm">
      <div class="font-semibold">
        Ответ магазина
        <time class="font-normal text-muted" :datetime="props.review.reply.created">{{ replyDate }}</time>
      </div>
      <p class="whitespace-pre-wrap">
        {{ props.review.reply.text }}
      </p>
    </div>
  </article>
</template>

<script setup lang="ts">
import type { ShowcaseReviewDto } from '@repo/api/web/models'

import RatingStars from './RatingStars.vue'
import ReviewPhotosLightbox from './ReviewPhotosLightbox.vue'
import { keyAttributesLabel } from '../utils/reviewsFormat'

const props = defineProps<{ review: ShowcaseReviewDto }>()

const { formatDate } = useFormatter()

const date = computed(() => formatDate(props.review.date, Formats.DATE_FORMAT_LONG))
const replyDate = computed(() =>
  props.review.reply?.created
    ? formatDate(props.review.reply.created, Formats.DATE_FORMAT_LONG)
    : '',
)
const attributes = computed(() => keyAttributesLabel(props.review.keyAttributes ?? []))
</script>
